import './social_content_view.js.coffee'
Namespace 'Monitoring.Views.SocialContents'

class Monitoring.Views.SocialContents.CemSurveyResponseContentView extends Monitoring.Views.SocialContents.SocialContentView
  className: 'content survey-content'

  _extendedModel: ->
    extendedModel = super
    extendedModel.responses = @_enhancedResponses()
    extendedModel

  _renderSentiment: ->
    undefined

  _detailsView: ->
    new Monitoring.Views.SocialContents.SurveyContentDetailsView
      model: @model

  _enhancedResponses: ->
    _.each @model._getContent().getResponses(), (response) =>
      if response.type == 'Keepcon::Surveys::TextItem'
        _.extend(response, {enhancedValue: @_enhancedValue(response.code, response.value)})

  _enhancedValue: (field, text) ->
    @model.getContentEnhancer(text).getContent({evidenceField: field, addAnchors: false})
